module.exports = __webpack_public_path__ + "img/03-title-02.1eeab2a4.png";